import React from 'react'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Email from '@mui/icons-material/Email';
import Phone from '@mui/icons-material/Phone';
import '../styles/Footer.css'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next';

function Footer() {
const {t} = useTranslation();

  return (
    <footer>
    <div className="footer-content">
        <div className="footer-section-about">
            <h3 className="logo-text" style={{fontWeight: '700'}}>Nutrition and Chemical Market</h3>
            <p>
            {t('footer_text')}
            </p>
            <div className="socials">
                <a
                    href="https://www.linkedin.com/company/nutrition-and-chemical-market/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className="linkedin-container">
                        <LinkedInIcon />
                    </div>
                </a>
            </div>
        </div>

        <div className="footer-section mobile-hide">
            <ul>
                <li><Link to="/nosotros">{t('about_us')}</Link></li>
                <li><Link to="/productos">{t('products')}</Link></li>
                <li><Link to="/servicios">{t('services')}</Link></li>
                <li><Link to="/contacto">{t('contact_us')}</Link></li>
                <li><a href="/personal_data_policy.pdf" target="_blank" rel="noopener noreferrer">{t('personal_data_policy')}</a></li>
            </ul>
        </div>

        <div className="contact">
                <li> <Email style={{ fontSize: 20, marginRight: 5 }} /> &nbsp; ventas@nutrimarketchemicals.com</li>
                <li> <Phone style={{ fontSize: 20, marginRight: 5 }} /> &nbsp; +57 314 2436964 - +57 316 5239821 </li>
        </div>
    </div>
    
    <div className="footer-bottom">
        <hr />
        <div className="footer-bottom">
            &copy; 2024 nutritionmarket.net
        </div>
    </div>
    </footer>
  )
}

export default Footer